module.exports = __webpack_public_path__ + "img/story022@2x.f577734f.png";